export const Functions = {
  create: false,
  delete: true,
  detail: false,
  search: true
};
export const PageName = '充值管理';